import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireModule } from '../../../app/guards'

/** Human resources (ADR-048): an opt-in module; every page below needs the company to have it. */
export const Route = createFileRoute('/_app/hr')({
  beforeLoad: ({ context }) => requireModule(context.session, 'hr'),
  component: Outlet,
})
